import { PageLayout } from '@bpm-web-app/components';
import { CuratedSetDetail } from '@bpm-web-app/components/pages';

const CuratedSetDetailPage = () => (
    <PageLayout>
        <CuratedSetDetail />
    </PageLayout>
);

export default CuratedSetDetailPage;
